import React, { useState } from 'react';
import Input from '@material-ui/core/Input';
import { makeStyles } from '@material-ui/core/styles';
import { APP_SECTION_GENERAL } from 'colours';

import ButtonGroup from '@material-ui/core/ButtonGroup';
import IconButton from '@material-ui/core/IconButton';

import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import DebounceValue from 'on_web/components/shared/NumericalInput/DebounceValue/DebounceValue';

const useStylesHtml = makeStyles(theme => ({
  tooltip: {
    backgroundColor: '#ffc9c9',
    color: '#222222',
    maxWidth: 220,
    fontFamily: 'Museo-500',
    fontSize: '14px',
    border: '1px solid #ffc9c9',
  },
  arrow: {
    color: '#ffc9c9',
  },
}));

export default function NumericalInput(props) {
  const [showInvalidInputTooltip, setShowInvalidInputTooltip] = useState(false);
  const [inputValue, setInputValue] = useState(props.value);
  const debouncedShowInvalidInputTooltip = DebounceValue(
    showInvalidInputTooltip,
    500
  );
  const debouncedInputValue = DebounceValue(inputValue, 500);
  const [inputFocusActivated, setInputFocusActivated] = useState(
    props.autoFocus ? true : false
  );

  const useStylesInput = makeStyles({
    root: {
      '& .MuiInputBase-input': {
        fontWeight: 'bold',
        fontSize: '50px',
        color: APP_SECTION_GENERAL,
        textAlign: 'center',
        width: 100,
        // hides arrows from input number
        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          '-moz-appearance': 'none',
          margin: 0,
        },
        '&[type=number]': {
          '-webkit-appearance': 'textfield',
          '-moz-appearance': 'textfield',
        },
      },
    },
  });
  const useStylesButton = makeStyles({
    root: {
      padding: 0,
      margin: 0,
      marginLeft: 5,
      marginRight: 5,
    },
  });
  const useStylesIcon = makeStyles({
    root: {
      fontSize: 50,
      color: APP_SECTION_GENERAL,
    },
  });
  const classesInput = useStylesInput();
  const classesButton = useStylesButton();
  const classesIcon = useStylesIcon();

  const handleInputChange = value => {
    const newValue = Number(value);
    const isInvalid =
      !(newValue >= props.inputProps.min) ||
      !(newValue <= props.inputProps.max);
    setShowInvalidInputTooltip(isInvalid);
    setInputValue(newValue);
    props.onChange(newValue);
  };

  const onInvalidInput = () => {
    setShowInvalidInputTooltip(true);
  };

  const HtmlTooltip = props => {
    const classes = useStylesHtml();

    return (
      <Tooltip
        arrow
        classes={classes}
        open={
          debouncedInputValue === inputValue &&
          debouncedShowInvalidInputTooltip &&
          showInvalidInputTooltip
        }
        disableFocusListener
        disableHoverListener
        disableTouchListener
        {...props}
      />
    );
  };

  return (
    <Grid container direction="row" justify="center" alignItems="center">
      <Grid
        item
        xs={props.showArrows ? 6 : 12}
        align={props.showArrows ? 'right' : 'center'}
      >
        <HtmlTooltip
          title={
            <React.Fragment>
              {props.numericalInputValueValidationMsg}
            </React.Fragment>
          }
        >
          <Input
            className={classesInput.root}
            value={inputValue}
            onChange={e => handleInputChange(e.target.value)}
            inputProps={props.inputProps}
            autoFocus={inputFocusActivated}
            onFocus={() => {
              setInputFocusActivated(true);
            }}
            onBlur={() => {
              setInputFocusActivated(false);
            }}
          />
        </HtmlTooltip>
      </Grid>
      {props.showArrows && (
        <Grid item xs={6} align="left">
          <ButtonGroup
            orientation="vertical"
            color="primary"
            aria-label="vertical outlined primary button group"
          >
            <IconButton
              aria-label="up"
              className={classesButton.root}
              onClick={() => {
                inputValue < props.inputProps.max
                  ? handleInputChange(inputValue + 1)
                  : inputValue == null
                  ? handleInputChange(props.inputProps.min)
                  : onInvalidInput();
              }}
              style={{
                marginBottom: '-10px',
              }}
            >
              <ArrowDropUpIcon className={classesIcon.root} />
            </IconButton>
            <IconButton
              aria-label="down"
              className={classesButton.root}
              onClick={() => {
                inputValue > props.inputProps.min
                  ? handleInputChange(inputValue - 1)
                  : inputValue == null
                  ? handleInputChange(props.inputProps.min)
                  : onInvalidInput();
              }}
              style={{
                marginTop: '-10px',
              }}
            >
              <ArrowDropDownIcon className={classesIcon.root} />
            </IconButton>
          </ButtonGroup>
        </Grid>
      )}
    </Grid>
  );
}
